import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Calendar, ArrowRight, Filter } from 'lucide-react';
import { newsArticles as fallback } from '../mock';
import { useLang } from '../i18n/LanguageContext';
import { api } from '../services/api';
import HutRiWatermark from '../components/HutRiWatermark';

const News = () => {
  const { t, tv, lang } = useLang();
  const [filter, setFilter] = useState('ALL');
  const [articles, setArticles] = useState(fallback);

  useEffect(() => {
    api.listNews().then((d) => { if (d && d.length) setArticles(d); }).catch(() => {});
  }, []);

  const cats = ['ALL', ...new Set(articles.map((n) => n.category))];
  const list = filter === 'ALL' ? articles : articles.filter((n) => n.category === filter);
  const featured = list[0];
  const rest = list.slice(1);

  return (
    <>
      <div className="relative h-[320px] bg-[#0a1929] overflow-hidden">
        <img src="https://images.unsplash.com/photo-1678353888985-6f2659bef53a" alt="" className="absolute inset-0 w-full h-full object-cover opacity-40" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0a1929]/50 to-[#0a1929]" />
        <HutRiWatermark size="md" />
        <div className="relative max-w-7xl mx-auto px-4 h-full flex flex-col justify-end pb-10">
          <div className="h-[3px] w-16 bg-[#d4a017] mb-3" />
          <div className="text-[#d4a017] text-xs tracking-[0.3em] uppercase mb-2">{lang === 'id' ? 'Kegiatan • Publikasi' : 'Activities • Publications'}</div>
          <h1 className="text-white text-5xl md:text-6xl font-bold tracking-wide" style={{ fontFamily: "'Roboto Condensed', sans-serif" }}>{t('latestNews')}</h1>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-10">
        <div className="flex flex-wrap items-center gap-2 mb-8 border-b border-gray-200 pb-4">
          <Filter size={16} className="text-[#0a1929] mr-2" />
          {cats.map((c) => (
            <button key={c} onClick={() => setFilter(c)} className={`px-4 py-1.5 text-xs font-bold tracking-widest uppercase transition ${filter === c ? 'bg-[#0a1929] text-white' : 'bg-transparent text-gray-600 hover:bg-gray-100'}`}>
              {c === 'ALL' ? t('all') : c}
            </button>
          ))}
        </div>

        {featured && (
          <Link to={`/berita/${featured.slug || featured.id}`} className="grid md:grid-cols-2 gap-8 mb-12 group">
            <div className="relative aspect-[16/10] overflow-hidden bg-[#0a1929]">
              <img src={featured.image} alt={tv(featured.title)} className="w-full h-full object-cover group-hover:scale-105 transition duration-700" />
              <div className="absolute top-4 left-4 bg-[#d4a017] text-[#0a1929] text-xs font-bold px-3 py-1.5 tracking-widest">{featured.category}</div>
            </div>
            <div className="flex flex-col justify-center">
              <div className="flex items-center gap-2 text-gray-500 text-xs mb-3"><Calendar size={14} /> {featured.date}</div>
              <h2 className="text-3xl md:text-4xl font-bold text-[#0a1929] mb-4 leading-tight group-hover:text-[#d4a017] transition" style={{ fontFamily: "'Roboto Condensed', sans-serif" }}>{tv(featured.title)}</h2>
              <p className="text-gray-700 leading-relaxed mb-5">{tv(featured.excerpt)}</p>
              <span className="inline-flex items-center gap-2 text-[#0a1929] font-bold text-sm tracking-widest uppercase">{t('readMore')} <ArrowRight size={14} /></span>
            </div>
          </Link>
        )}

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {rest.map((n) => (
            <Link key={n.id} to={`/berita/${n.slug || n.id}`} className="group bg-white border border-gray-200 hover:border-[#d4a017] hover:shadow-lg transition">
              <div className="relative aspect-[16/10] overflow-hidden bg-[#0a1929]">
                <img src={n.image} alt={tv(n.title)} className="w-full h-full object-cover group-hover:scale-105 transition duration-500" />
                <div className="absolute top-3 left-3 bg-[#0a1929] text-[#d4a017] text-[10px] font-bold px-2 py-1 tracking-widest">{n.category}</div>
              </div>
              <div className="p-5">
                <div className="flex items-center gap-2 text-gray-500 text-xs mb-2"><Calendar size={12} /> {n.date}</div>
                <h3 className="text-lg font-bold text-[#0a1929] mb-2 leading-snug group-hover:text-[#d4a017] transition" style={{ fontFamily: "'Roboto Condensed', sans-serif" }}>{tv(n.title)}</h3>
                <p className="text-gray-600 text-sm leading-relaxed line-clamp-2">{tv(n.excerpt)}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </>
  );
};

export default News;
